import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-survey-template',
    templateUrl: './survey-template.component.html',
    styleUrls: ['./survey-template.component.scss'],
    imports:[RouterModule],
     changeDetection: ChangeDetectionStrategy.Default
})
export class SurveyTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
